import { render, staticRenderFns } from "./addSeed.vue?vue&type=template&id=6afd19ff&"
import script from "./addSeed.vue?vue&type=script&lang=js&"
export * from "./addSeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports